import type { PropsWithChildren } from 'react'

import {
  MantineProvider,
  useComputedColorScheme,
  useMantineColorScheme,
  v8CssVariablesResolver,
} from '@mantine/core'
import { useHotkeys } from '@mantine/hooks'

import { theme } from './helpers'

const enableColorSchemeHotkey =
  process.env.NODE_ENV === 'development' ||
  window.scriptoEnvironment === 'staging'

// The entire app gets wrapped in this theme provider, so anything we write automatically
// gets access to the settings configured above.
export interface ThemeProviderProps extends PropsWithChildren {
  forceColorScheme?: 'light' | 'dark'
}

export const ThemeProvider = (props: ThemeProviderProps) => {
  return (
    <MantineProvider
      theme={theme}
      cssVariablesResolver={v8CssVariablesResolver}
      forceColorScheme={props.forceColorScheme}
    >
      {props.children}
      {enableColorSchemeHotkey && <ColorChanger />}
    </MantineProvider>
  )
}

function ColorChanger() {
  const { setColorScheme } = useMantineColorScheme()
  const colorScheme = useComputedColorScheme('light')

  function toggleColorScheme() {
    setColorScheme(colorScheme === 'dark' ? 'light' : 'dark')
  }

  useHotkeys([['ctrl+j', toggleColorScheme]])

  return null
}
